import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { StringSerializer_getInstance2wffkbpdux3h9 as StringSerializer_getInstance } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Primitives.mjs';
import {
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  createThis2j2avj17cvnv2 as createThis,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      m2a() {
        return $serializer_getInstance();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        $serializer_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.auth.old.EmailPinLogin', this, 2);
        tmp0_serialDesc.c1b('email', false);
        tmp0_serialDesc.c1b('pin', false);
        this.c4e_1 = tmp0_serialDesc;
      }
      d4e(encoder, value) {
        var tmp0_desc = this.c4e_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        tmp1_output.a15(tmp0_desc, 0, value.e4e_1);
        tmp1_output.a15(tmp0_desc, 1, value.f4e_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.d4e(encoder, value instanceof EmailPinLogin() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.c4e_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.l13(tmp0_desc);
        if (tmp6_input.a14()) {
          tmp4_local0 = tmp6_input.v13(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.v13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.v13(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.v13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp6_input.m13(tmp0_desc);
        return EmailPinLogin().g4e(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      az() {
        return this.c4e_1;
      }
      t1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), StringSerializer_getInstance()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var $serializer_instance;
function $serializer_getInstance() {
  if ($serializer_instance === VOID)
    new ($serializer())();
  return $serializer_instance;
}
var EmailPinLoginClass;
function EmailPinLogin() {
  if (EmailPinLoginClass === VOID) {
    class $ {
      toString() {
        return 'EmailPinLogin(email=' + this.e4e_1 + ', pin=' + this.f4e_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.e4e_1);
        result = imul(result, 31) + getStringHashCode(this.f4e_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof EmailPinLogin()))
          return false;
        if (!(this.e4e_1 === other.e4e_1))
          return false;
        if (!(this.f4e_1 === other.f4e_1))
          return false;
        return true;
      }
      static g4e(seen0, email, pin, serializationConstructorMarker) {
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, $serializer_getInstance().c4e_1);
        }
        var $this = createThis(this);
        $this.e4e_1 = email;
        $this.f4e_1 = pin;
        return $this;
      }
    }
    initMetadataForClass($, 'EmailPinLogin', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance});
    EmailPinLoginClass = $;
  }
  return EmailPinLoginClass;
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      m2a() {
        return $serializer_getInstance_0();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  return Companion_instance_0;
}
var $serializerClass_0;
function $serializer_0() {
  if ($serializerClass_0 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_0 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.auth.old.PhonePinLogin', this, 2);
        tmp0_serialDesc.c1b('phone', false);
        tmp0_serialDesc.c1b('pin', false);
        this.h4e_1 = tmp0_serialDesc;
      }
      i4e(encoder, value) {
        var tmp0_desc = this.h4e_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        tmp1_output.a15(tmp0_desc, 0, value.j4e_1);
        tmp1_output.a15(tmp0_desc, 1, value.k4e_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.i4e(encoder, value instanceof PhonePinLogin() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.h4e_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.l13(tmp0_desc);
        if (tmp6_input.a14()) {
          tmp4_local0 = tmp6_input.v13(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.v13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.v13(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.v13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp6_input.m13(tmp0_desc);
        return PhonePinLogin().l4e(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      az() {
        return this.h4e_1;
      }
      t1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), StringSerializer_getInstance()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_0 = $;
  }
  return $serializerClass_0;
}
var $serializer_instance_0;
function $serializer_getInstance_0() {
  if ($serializer_instance_0 === VOID)
    new ($serializer_0())();
  return $serializer_instance_0;
}
var PhonePinLoginClass;
function PhonePinLogin() {
  if (PhonePinLoginClass === VOID) {
    class $ {
      toString() {
        return 'PhonePinLogin(phone=' + this.j4e_1 + ', pin=' + this.k4e_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.j4e_1);
        result = imul(result, 31) + getStringHashCode(this.k4e_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof PhonePinLogin()))
          return false;
        if (!(this.j4e_1 === other.j4e_1))
          return false;
        if (!(this.k4e_1 === other.k4e_1))
          return false;
        return true;
      }
      static l4e(seen0, phone, pin, serializationConstructorMarker) {
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, $serializer_getInstance_0().h4e_1);
        }
        var $this = createThis(this);
        $this.j4e_1 = phone;
        $this.k4e_1 = pin;
        return $this;
      }
    }
    initMetadataForClass($, 'PhonePinLogin', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_0});
    PhonePinLoginClass = $;
  }
  return PhonePinLoginClass;
}
var CompanionClass_1;
function Companion_1() {
  if (CompanionClass_1 === VOID) {
    class $ {
      m2a() {
        return $serializer_getInstance_1();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_1 = $;
  }
  return CompanionClass_1;
}
var Companion_instance_1;
function Companion_getInstance_1() {
  return Companion_instance_1;
}
var $serializerClass_1;
function $serializer_1() {
  if ($serializerClass_1 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_1 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.auth.old.PasswordLogin', this, 2);
        tmp0_serialDesc.c1b('username', false);
        tmp0_serialDesc.c1b('password', false);
        this.m4e_1 = tmp0_serialDesc;
      }
      n4e(encoder, value) {
        var tmp0_desc = this.m4e_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        tmp1_output.a15(tmp0_desc, 0, value.o4e_1);
        tmp1_output.a15(tmp0_desc, 1, value.p4e_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.n4e(encoder, value instanceof PasswordLogin() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.m4e_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.l13(tmp0_desc);
        if (tmp6_input.a14()) {
          tmp4_local0 = tmp6_input.v13(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.v13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.v13(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.v13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp6_input.m13(tmp0_desc);
        return PasswordLogin().q4e(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      az() {
        return this.m4e_1;
      }
      t1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), StringSerializer_getInstance()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_1 = $;
  }
  return $serializerClass_1;
}
var $serializer_instance_1;
function $serializer_getInstance_1() {
  if ($serializer_instance_1 === VOID)
    new ($serializer_1())();
  return $serializer_instance_1;
}
var PasswordLoginClass;
function PasswordLogin() {
  if (PasswordLoginClass === VOID) {
    class $ {
      toString() {
        return 'PasswordLogin(username=' + this.o4e_1 + ', password=' + this.p4e_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.o4e_1);
        result = imul(result, 31) + getStringHashCode(this.p4e_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof PasswordLogin()))
          return false;
        if (!(this.o4e_1 === other.o4e_1))
          return false;
        if (!(this.p4e_1 === other.p4e_1))
          return false;
        return true;
      }
      static q4e(seen0, username, password, serializationConstructorMarker) {
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, $serializer_getInstance_1().m4e_1);
        }
        var $this = createThis(this);
        $this.o4e_1 = username;
        $this.p4e_1 = password;
        return $this;
      }
    }
    initMetadataForClass($, 'PasswordLogin', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_1});
    PasswordLoginClass = $;
  }
  return PasswordLoginClass;
}
//region block: init
Companion_instance = new (Companion())();
Companion_instance_0 = new (Companion_0())();
Companion_instance_1 = new (Companion_1())();
//endregion
//region block: exports
export {
  Companion_instance as Companion_instanceoexmrian6dpx,
  Companion_instance_1 as Companion_instance3pds0w11gibwr,
  Companion_instance_0 as Companion_instance1d4dbx3jji78w,
};
//endregion

//# sourceMappingURL=EmailPinLogin.mjs.map
